function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "T\xEDtulo Dashboard");

var SvgDashTitle = function SvgDashTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("rect", {
    x: 5.43,
    y: 41.47,
    width: 13.06,
    height: 13.06,
    rx: 1.32,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 22.19,
    y: 41.47,
    width: 32.38,
    height: 3.91,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("rect", {
    x: 22.19,
    y: 47.02,
    width: 32.38,
    height: 1.96,
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M79.28,41.47a3.09,3.09,0,1,0,3.09,3.09A3.09,3.09,0,0,0,79.28,41.47Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M87.49,41.47a3.09,3.09,0,1,0,3.08,3.09A3.09,3.09,0,0,0,87.49,41.47Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DASH-TITLE.971b3ef8.svg";
export { ForwardRef as ReactComponent };